import { ENVS } from '../consts';

export const getCasdoorAccessToken = () => window.localStorage.getItem('casdoor_access_token') || '';

export const getCasdoorRefreshToken = () => window.localStorage.getItem('casdoor_refresh_token') || '';

export const removeTokens = () => {
  window.localStorage.removeItem('casdoor_access_token');
  window.localStorage.removeItem('casdoor_refresh_token');
  window.localStorage.removeItem('lms_access_token');
  window.localStorage.removeItem('lms_refresh_token');
};

// TODO Remove after DEV-33177 release
export const removeOldLMSTokens = () => {
  window.localStorage.removeItem('teachbase_access_token');
  window.localStorage.removeItem('teachbase_refresh_token');
};

export const saveCasdoorTokens = ({
  casdoorAccessToken,
  casdoorRefreshToken,
}: {
  casdoorAccessToken: string;
  casdoorRefreshToken: string;
}) => {
  window.localStorage.setItem('casdoor_access_token', casdoorAccessToken);
  window.localStorage.setItem('casdoor_refresh_token', casdoorRefreshToken);
};

export const getLMSAccessToken = () => window.localStorage.getItem('lms_access_token') || '';

export const getLMSRefreshToken = () => window.localStorage.getItem('lms_refresh_token') || '';

export const saveLMSTokens = ({
  lmsAccessToken,
  lmsRefreshToken,
}: {
  lmsAccessToken: string;
  lmsRefreshToken: string;
}) => {
  window.localStorage.setItem('lms_access_token', lmsAccessToken);
  window.localStorage.setItem('lms_refresh_token', lmsRefreshToken);
};

export const getSSOUrlToRedirect = ({
  type,
  redirectUri,
  redirectPath,
}: {
  type: 'signin' | 'signup' | 'logout' | 'admin';
  redirectUri: string;
  redirectPath?: string;
}) => {
  if (typeof window === 'undefined') {
    return '';
  }

  const url = new URL(type, ENVS.SSO_SITE_URL);
  url.searchParams.append('redirectUri', redirectUri);

  if (redirectPath) {
    url.searchParams.append('redirectPath', redirectPath);
  }

  return url.toString();
};

export const getPublicSiteUrl = () => window.location.origin || ENVS.PUBLIC_URL;

export const logoutUser = () => {
  removeTokens();

  window.location.href = getSSOUrlToRedirect({ type: 'logout', redirectUri: ENVS.LMS_LOGOUT_URL });
};
